import { Link } from "react-router-dom";
import { Card, Nav, NavItem } from "reactstrap";
import PeopleKnowWidget from "common/PeopleKnowWidget";
import { useSelector } from "react-redux";
import { isPractitioner } from "utils/UserHelper";
import JobWidget from "common/JobWidget";

const ManageJobSideBar = () => {
  const currentUser = useSelector((state) => state.auth.currentUser);
  const { primarySpeciality } = currentUser;
  return (
    <>
      {isPractitioner() && primarySpeciality &&
        <>
          <PeopleKnowWidget speciality={primarySpeciality} />
          <JobWidget widgetTitle="Recommended Jobs" primarySpeciality={primarySpeciality} />
        </>
      }
    </>
  );
};

export default ManageJobSideBar;
